import SharingPopup from './SharingPopup';

export default SharingPopup;
